import ContainerSkeleton from "./ContainerSkeleton"

const ProductCardsSkeleton = ({ count = 0 }) => {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div key={i}>
          <ContainerSkeleton custW="w-full" custH="h-[170px] sm:h-[330px] lg:h-[350px]" custCls="mb-4" />
          <ContainerSkeleton custW="w-4/5" custH="h-5 sm:h-7 lg:h-8" custCls="mb-1" />
          <ContainerSkeleton custW="w-1/3" custH="h-4 sm:h-5 lg:h-6" />
        </div>
      ))}
    </>
  )
}

const ProductCardsRowSkeleton = ({ count = 0 }) => {
  return (
    <div className="w-[90%] lg:w-[80%] mx-auto grid grid-cols-2 lg:grid-cols-3 gap-x-4 sm:gap-x-8 gap-y-8 sm:gap-y-16 pb-16">
      <ProductCardsSkeleton count={count} />
    </div>
  )
}

export {
  ProductCardsSkeleton,
  ProductCardsRowSkeleton
}
